module.exports = __webpack_public_path__ + "img/full.4d75d05d.png";